// torre-inbox · Inbox IA + Mailboxes + KB
import {
  initAuth, getAuthContext, signInWithGoogle, signInWithMagicLink,
  applyTheme, createOrbitBackground,
  fetchJson, fmtBR, fmtDate, fmtDateTime, escapeHtml
} from '@zzyonbr/torre-shared';

const $ = sel => document.querySelector(sel);
const $$ = sel => Array.from(document.querySelectorAll(sel));

async function bootstrap() {
  await initAuth();
  const ctx = await getAuthContext();
  applyTheme(ctx.tenant?.branding || {});
  if (!ctx.user) { renderLogin(); return; }
  renderShell(ctx);
  setActiveTab(location.hash.slice(1) || 'inbox');
  window.addEventListener('hashchange', () => setActiveTab(location.hash.slice(1) || 'inbox'));
}

function renderLogin() {
  $('#app').innerHTML = `
    <div class="zzy-fade-up" style="min-height:100vh;display:flex;align-items:center;justify-content:center;padding:24px;position:relative;overflow:hidden">
      <div id="orbit-host" style="position:absolute;inset:0;pointer-events:none"></div>
      <div class="zzy-card" style="max-width:440px;width:100%;text-align:center;padding:48px 36px">
        <div style="display:flex;justify-content:center;margin-bottom:28px"><zzy-logo size="56" sub="true"></zzy-logo></div>
        <div style="font:400 13px/1.4 var(--zzy-font);color:var(--zzy-text-mute);font-style:italic;margin-bottom:32px">Inteligência em órbita</div>
        <div style="height:1px;background:var(--zzy-border);margin:0 -36px 28px -36px"></div>
        <div class="zzy-eyebrow" style="margin-bottom:8px">Torre de Controle</div>
        <div class="zzy-h3" style="margin-bottom:28px">Inbox</div>
        <button id="login-google" class="zzy-btn" style="width:100%;background:#FFFFFF;color:#1F1F1F;display:flex;align-items:center;justify-content:center;gap:10px;margin-bottom:12px">
          <svg width="18" height="18" viewBox="0 0 24 24"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84C6.71 7.31 9.14 5.38 12 5.38z"/></svg>
          Entrar com Google
        </button>
        <div style="display:flex;align-items:center;gap:10px;margin:14px 0;color:var(--zzy-text-mute);font:400 11px/1 var(--zzy-font);text-transform:uppercase;letter-spacing:.1em">
          <span style="flex:1;height:1px;background:var(--zzy-border)"></span>ou<span style="flex:1;height:1px;background:var(--zzy-border)"></span>
        </div>
        <input id="email" type="email" placeholder="seu.email@empresa.com" class="zzy-input" style="margin-bottom:12px" />
        <button id="login-btn" class="zzy-btn zzy-btn--ghost" style="width:100%">Receber Magic Link por email</button>
        <div id="login-msg" style="margin-top:14px;font:400 12px/1.4 var(--zzy-font);color:var(--zzy-text-mute);min-height:18px"></div>
      </div>
    </div>
  `;
  $('#orbit-host')?.appendChild(createOrbitBackground());
  $('#login-google').addEventListener('click', () => signInWithGoogle(location.origin).catch(e => $('#login-msg').textContent = 'Erro: ' + e.message));
  $('#login-btn').addEventListener('click', async () => {
    const email = $('#email').value.trim();
    if (!email) { $('#login-msg').textContent = 'Informe um email'; return; }
    try { await signInWithMagicLink(email, location.origin); $('#login-msg').textContent = 'Link enviado!'; $('#login-msg').style.color = 'var(--zzy-success)'; }
    catch (err) { $('#login-msg').textContent = 'Erro: ' + err.message; $('#login-msg').style.color = 'var(--zzy-danger)'; }
  });
}

function renderShell(ctx) {
  $('#app').innerHTML = `
    <zzy-toast></zzy-toast>
    <zzy-header module="Inbox"></zzy-header>
    <main style="max-width:1500px;margin:0 auto;padding:24px">
      <nav id="tabs" style="display:flex;gap:8px;margin-bottom:20px;border-bottom:1px solid var(--zzy-border);overflow-x:auto">
        <button data-tab="inbox"     class="ib-tab ib-tab--active">Inbox emails</button>
        <button data-tab="mailboxes" class="ib-tab">Mailboxes</button>
        <button data-tab="kb"        class="ib-tab">Knowledge Base</button>
        <button data-tab="esl-kb"    class="ib-tab">ESL KB</button>
      </nav>
      <section id="content"></section>
    </main>
    <style>
      .ib-tab { background:transparent;border:0;color:var(--zzy-text-mute);padding:10px 18px;font:500 13px/1 var(--zzy-font);cursor:pointer;border-bottom:2px solid transparent;margin-bottom:-1px;transition:color .15s,border-color .15s;white-space:nowrap; }
      .ib-tab:hover { color:var(--zzy-mist); }
      .ib-tab--active { color:var(--zzy-sky);border-bottom-color:var(--zzy-sky); }
      .ib-table { width:100%;border-collapse:collapse;font-size:12.5px; }
      .ib-table th { text-align:left;color:var(--zzy-text-mute);font:600 10px/1 var(--zzy-font);text-transform:uppercase;letter-spacing:.08em;padding:10px 12px;border-bottom:1px solid var(--zzy-border);position:sticky;top:0;background:var(--zzy-surface-solid);z-index:1; }
      .ib-table td { padding:10px 12px;border-bottom:1px solid var(--zzy-border);vertical-align:top; }
      .ib-table tr:hover td { background:rgba(255,255,255,.02); }
      .ib-stat { display:flex;gap:12px;flex-wrap:wrap;margin-bottom:20px; }
      .ib-filter-bar { display:flex;gap:12px;flex-wrap:wrap;align-items:end;margin-bottom:16px; }
      .ib-filter { display:flex;flex-direction:column;gap:4px; }
      .ib-filter label { font:500 10px/1 var(--zzy-font);color:var(--zzy-text-mute);text-transform:uppercase;letter-spacing:.08em; }
      .ib-filter select, .ib-filter input { background:rgba(255,255,255,.03);border:1px solid var(--zzy-border);color:var(--zzy-mist);padding:8px 10px;border-radius:6px;font:400 13px/1 var(--zzy-font);min-width:140px;outline:none; }
      .ib-badge { display:inline-block;padding:2px 8px;border-radius:4px;font:600 10px/1.4 var(--zzy-font);text-transform:uppercase;letter-spacing:.04em; }
    </style>
  `;
  $$('.ib-tab').forEach(b => b.addEventListener('click', () => { location.hash = b.dataset.tab; setActiveTab(b.dataset.tab); }));
}

function setActiveTab(name) {
  $$('.ib-tab').forEach(b => b.classList.toggle('ib-tab--active', b.dataset.tab === name));
  if (name === 'inbox') loadInbox();
  if (name === 'mailboxes') loadMailboxes();
  if (name === 'kb') loadKB();
  if (name === 'esl-kb') loadEslKB();
}

// ============================================================
// ABA · INBOX EMAILS (mv_inbox_ml + agrupar por assunto)
// ============================================================
let _allInbox = [];
async function loadInbox() {
  $('#content').innerHTML = `<zzy-spinner>Carregando inbox emails IA…</zzy-spinner>`;
  try {
    _allInbox = await fetchJson('/mv_inbox_ml?select=*&order=received_at.desc.nullslast&limit=500').catch(() =>
      fetchJson('/inbox_emails?select=*&order=received_at.desc.nullslast&limit=500').catch(() => [])
    );
    renderInbox();
  } catch (err) {
    $('#content').innerHTML = `<div class="zzy-card" style="color:var(--zzy-danger)">Erro: ${escapeHtml(err.message)}</div>`;
  }
}
window.__reloadInbox = loadInbox;

function normSubject(s) {
  return (s || '').replace(/^(re|fw|fwd|enc|res):\s*/gi, '').trim().toLowerCase();
}

function renderInbox() {
  const fGroup = $('#ib-group')?.value || 'thread';
  const fCat = $('#ib-cat')?.value || '';
  const fQ = ($('#ib-q')?.value || '').toLowerCase().trim();

  let rows = _allInbox.filter(r => {
    if (fCat && r.categoria !== fCat) return false;
    if (fQ) {
      const hay = [r.subject, r.from_email, r.from_name, r.body, r.summary].filter(Boolean).join(' ').toLowerCase();
      if (!hay.includes(fQ)) return false;
    }
    return true;
  });

  // Agrupa por assunto se selecionado
  let groups = [];
  if (fGroup === 'thread') {
    const map = new Map();
    rows.forEach(r => {
      const k = normSubject(r.subject);
      if (!map.has(k)) map.set(k, []);
      map.get(k).push(r);
    });
    groups = Array.from(map.entries())
      .map(([k, arr]) => ({ subject: arr[0].subject || k, count: arr.length, latest: arr[0], all: arr }))
      .sort((a, b) => new Date(b.latest.received_at || 0) - new Date(a.latest.received_at || 0));
  }

  const cats = Array.from(new Set(_allInbox.map(r => r.categoria).filter(Boolean))).sort();
  const total = _allInbox.length;
  const pendentes = _allInbox.filter(r => !r.respondido && !r.resolvido).length;

  $('#content').innerHTML = `
    <div class="ib-stat">
      <zzy-stat-card label="Total emails" value="${fmtBR(total)}" color="primary"></zzy-stat-card>
      <zzy-stat-card label="Pendentes" value="${fmtBR(pendentes)}" color="warning"></zzy-stat-card>
      <zzy-stat-card label="Threads únicas" value="${fmtBR(groups.length)}" color="info"></zzy-stat-card>
      <zzy-stat-card label="Categorias" value="${fmtBR(cats.length)}" color="primary"></zzy-stat-card>
    </div>
    <div class="zzy-card" style="margin-bottom:16px">
      <div class="ib-filter-bar">
        <div class="ib-filter">
          <label>Agrupar</label>
          <select id="ib-group">
            <option value="thread" ${fGroup==='thread'?'selected':''}>Por assunto (thread)</option>
            <option value="none"   ${fGroup==='none'?'selected':''}>Não agrupar</option>
          </select>
        </div>
        <div class="ib-filter">
          <label>Categoria</label>
          <select id="ib-cat">
            <option value="">Todas</option>
            ${cats.map(c => `<option value="${escapeHtml(c)}" ${c===fCat?'selected':''}>${escapeHtml(c)}</option>`).join('')}
          </select>
        </div>
        <div class="ib-filter" style="flex:1;min-width:240px">
          <label>Buscar</label>
          <input id="ib-q" type="text" value="${escapeHtml(fQ)}" placeholder="assunto, remetente, corpo, resumo…" />
        </div>
        <div class="ib-filter">
          <label>&nbsp;</label>
          <button class="zzy-btn zzy-btn--ghost" onclick="window.__reloadInbox()" style="padding:8px 14px">↻</button>
        </div>
      </div>
    </div>
    <div class="zzy-card" style="padding:0;overflow:auto;max-height:calc(100vh - 380px)">
      ${fGroup === 'thread' ? `
        <table class="ib-table">
          <thead><tr><th>Última msg</th><th>Assunto</th><th>Remetente</th><th>Mensagens</th><th>Categoria</th><th>Status</th></tr></thead>
          <tbody>
            ${groups.length ? groups.slice(0, 200).map(g => `<tr>
              <td><small>${fmtDateTime(g.latest.received_at)}</small></td>
              <td><strong>${escapeHtml((g.subject || '—').slice(0, 80))}</strong></td>
              <td>${escapeHtml(g.latest.from_name || g.latest.from_email || '—')}</td>
              <td><strong>${g.count}</strong></td>
              <td><small>${escapeHtml(g.latest.categoria || '—')}</small></td>
              <td>${g.latest.respondido ? '<span class="ib-badge" style="background:rgba(34,197,94,.18);color:#22C55E">RESPONDIDO</span>' : '<span class="ib-badge" style="background:rgba(245,158,11,.18);color:#F59E0B">PENDENTE</span>'}</td>
            </tr>`).join('') : '<tr><td colspan="6"><zzy-empty title="Sem emails"></zzy-empty></td></tr>'}
          </tbody>
        </table>
      ` : `
        <table class="ib-table">
          <thead><tr><th>Recebido</th><th>Assunto</th><th>Remetente</th><th>Categoria</th><th>Resumo IA</th><th>Status</th></tr></thead>
          <tbody>
            ${rows.length ? rows.slice(0, 300).map(r => `<tr>
              <td><small>${fmtDateTime(r.received_at)}</small></td>
              <td><strong>${escapeHtml((r.subject || '—').slice(0, 60))}</strong></td>
              <td>${escapeHtml(r.from_name || r.from_email || '—')}</td>
              <td><small>${escapeHtml(r.categoria || '—')}</small></td>
              <td><small style="color:var(--zzy-text-mute)">${escapeHtml((r.summary || r.resumo_ia || '—').slice(0,100))}</small></td>
              <td>${r.respondido ? '✅' : '⏳'}</td>
            </tr>`).join('') : '<tr><td colspan="6"><zzy-empty title="Sem emails"></zzy-empty></td></tr>'}
          </tbody>
        </table>
      `}
    </div>
  `;
  $('#ib-group')?.addEventListener('change', renderInbox);
  $('#ib-cat')?.addEventListener('change', renderInbox);
  $('#ib-q')?.addEventListener('input', () => clearTimeout(window.__ibQT) || (window.__ibQT = setTimeout(renderInbox, 250)));
}

// ============================================================
// ABA · MAILBOXES
// ============================================================
async function loadMailboxes() {
  $('#content').innerHTML = `<zzy-spinner>Carregando mailboxes…</zzy-spinner>`;
  try {
    const rows = await fetchJson('/mailboxes_config?select=*').catch(() =>
      fetchJson('/inbox_mailboxes?select=*').catch(() => [])
    );
    $('#content').innerHTML = `
      <div class="zzy-card">
        <h3 class="zzy-h3" style="margin:0 0 12px 0">Caixas configuradas</h3>
        ${rows.length ? `<table class="ib-table">
          <thead><tr><th>Email</th><th>Provedor</th><th>Status</th><th>Última sync</th><th>Total msgs</th></tr></thead>
          <tbody>${rows.map(r => `<tr>
            <td><strong>${escapeHtml(r.email || r.address || '—')}</strong></td>
            <td>${escapeHtml(r.provider || r.provedor || '—')}</td>
            <td>${escapeHtml(r.status || '—')}</td>
            <td>${fmtDateTime(r.last_sync || r.ultima_sync)}</td>
            <td>${fmtBR(r.total_messages || r.total_msgs)}</td>
          </tr>`).join('')}</tbody></table>` : '<zzy-empty title="View mailboxes não acessível" message="Configure caixas via OAuth Microsoft Graph (alertas@icaroexpress.com)"></zzy-empty>'}
      </div>
    `;
  } catch (err) {
    $('#content').innerHTML = `<div class="zzy-card" style="color:var(--zzy-danger)">Erro: ${escapeHtml(err.message)}</div>`;
  }
}

// ============================================================
// ABA · KB (Knowledge Base interna)
// ============================================================
async function loadKB() {
  $('#content').innerHTML = `<zzy-spinner>Carregando KB…</zzy-spinner>`;
  try {
    const rows = await fetchJson('/kb_articles?select=*&order=updated_at.desc.nullslast&limit=200').catch(() =>
      fetchJson('/cs_kb?select=*&limit=200').catch(() => [])
    );
    $('#content').innerHTML = `
      <div class="zzy-card">
        <h3 class="zzy-h3" style="margin:0 0 4px 0">Knowledge Base</h3>
        <p style="color:var(--zzy-text-mute);font-size:13px;margin:0 0 16px 0">Artigos, procedimentos, FAQs do CS.</p>
        ${rows.length ? `<table class="ib-table">
          <thead><tr><th>Título</th><th>Categoria</th><th>Atualizado</th><th>Visualizações</th></tr></thead>
          <tbody>${rows.map(r => `<tr>
            <td><strong>${escapeHtml(r.titulo || r.title || '—')}</strong></td>
            <td>${escapeHtml(r.categoria || r.category || '—')}</td>
            <td>${fmtDateTime(r.updated_at)}</td>
            <td>${fmtBR(r.views || r.visualizacoes)}</td>
          </tr>`).join('')}</tbody></table>` : '<zzy-empty title="KB vazia ou view não acessível"></zzy-empty>'}
      </div>
    `;
  } catch (err) {
    $('#content').innerHTML = `<div class="zzy-card" style="color:var(--zzy-danger)">Erro: ${escapeHtml(err.message)}</div>`;
  }
}

// ============================================================
// ABA · ESL KB
// ============================================================
async function loadEslKB() {
  $('#content').innerHTML = `<zzy-spinner>Carregando ESL KB…</zzy-spinner>`;
  try {
    const rows = await fetchJson('/esl_kb_documents?select=*&limit=100').catch(() => []);
    const stats = await fetchJson('/vw_esl_kb_stats?select=*&limit=10').catch(() => []);
    $('#content').innerHTML = `
      <div class="zzy-card" style="margin-bottom:16px">
        <h3 class="zzy-h3" style="margin:0 0 4px 0">ESL Knowledge Base</h3>
        <p style="color:var(--zzy-text-mute);font-size:13px;margin:0">Documentos ESL processados e indexados (CTes, manifestos, contratos).</p>
      </div>
      ${stats.length ? `<div class="ib-stat">
        ${stats.map(s => `<zzy-stat-card label="${escapeHtml(s.tipo || s.type || 'Total')}" value="${fmtBR(s.qtd || s.count)}" color="primary"></zzy-stat-card>`).join('')}
      </div>` : ''}
      <div class="zzy-card" style="padding:0;overflow:auto">
        <table class="ib-table">
          <thead><tr><th>Tipo</th><th>Identificador</th><th>Cliente</th><th>Indexado em</th></tr></thead>
          <tbody>${rows.length ? rows.map(r => `<tr>
            <td>${escapeHtml(r.tipo || r.type || '—')}</td>
            <td><strong>${escapeHtml(r.identifier || r.numero || '—')}</strong></td>
            <td>${escapeHtml(r.cliente || r.pagador || '—')}</td>
            <td>${fmtDateTime(r.indexed_at || r.created_at)}</td>
          </tr>`).join('') : '<tr><td colspan="4"><zzy-empty title="ESL KB vazio ou view não acessível"></zzy-empty></td></tr>'}</tbody>
        </table>
      </div>
    `;
  } catch (err) {
    $('#content').innerHTML = `<div class="zzy-card" style="color:var(--zzy-danger)">Erro: ${escapeHtml(err.message)}</div>`;
  }
}

bootstrap();
